import { Button, Grid } from "@mui/material";
import { useState, FormEvent } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { redirect, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { PaperHeader } from "../../_components/paper/header.paperComponent";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { RESET_PASSWORD_VALIDATORS, RESET_PASSWORD_ERROR_MESSAGES, RESET_PASSWORD_HELPER_TEXT } from "../../_const/security.const";
import { accountService } from "../../_services/accounts.service";
import { theme } from "../../_styles/theme.styles";

const useStyles = {
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: theme.spacing(2),
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        "&>div>div": {
            marginTop: "10px"
        }
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    header: {
        marginLeft: theme.spacing(-8),
    },
    appScreen: {
        backgroundColor: "#181c37",
        backgroundImage: "url('images/dark-tire.png')",
    },

    appLogo: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    appContainer: {
        paddingTop: theme.spacing(4),
    },
    backToLogin: {
        paddingTop: "20px",
        cursor: "pointer"
    }
};

export function LoginResetPassword() {

    const [password, setPassword] = useState("");
    const [username, setUsername] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setLoading] = useState(false);

    let { pathname } = useLocation();
    let code = pathname && pathname.indexOf("code=") ? pathname.split("code=")[1] : "";
    function submit(e: FormEvent) {
        e.preventDefault();
        setLoading(true);

        accountService.resetPassword(username, password, confirmPassword, code)
            .then(
                (item => {
                    toastr.success("Password reset successfully");
                    redirect('/');
                }),
                ((err) => {
                    toastr.error(err.Message || err.title || err || "Something went wrong. Please try again later");
                }))
            .finally(() => { setLoading(false); });
    }

    function goTo(link: string) {
        redirect('/' + link);
    }

    if (accountService.currentUserValue) {
        redirect('/');
    }

    function generateGuid() {
        var result, i, j;
        result = '';
        for (j = 0; j < 32; j++) {
            if (j == 8 || j == 12 || j == 16 || j == 20)
                result = result + '-';
            i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
            result = result + i;
        }
        return result;
    }

    return (
        <div style={useStyles.paper as React.CSSProperties}>
            <div style={useStyles.header}>
                <PaperHeader title='Reset Password' icon='lock'></PaperHeader>
            </div>
            <ValidatorForm sx={useStyles.form} onSubmit={submit} noValidate>

                <Grid container>
                    <Grid item xs={12}>

                        <TextValidatorHcs
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Email"
                            name="email"
                            value={username}
                            disabled={isLoading}
                            onChange={(e: any) => setUsername(e.target.value.toString())}
                            validators={['required', 'isEmail']}
                            errorMessages={['This field is required', 'Email is not valid']}
                            autoFocus
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextValidatorHcs
                            errorText={"test"}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            disabled={isLoading}
                            value={password}
                            withRequiredValidator
                            autoComplete={"current-password-" + generateGuid()}
                            onChange={(e: any) => setPassword(e.target.value.toString())}
                            validators={RESET_PASSWORD_VALIDATORS(true)}
                            errorMessages={RESET_PASSWORD_ERROR_MESSAGES(true)}
                            helperText={!password ? RESET_PASSWORD_HELPER_TEXT : "✓ Password is valid"} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextValidatorHcs
                            error={confirmPassword && password !== confirmPassword}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="confirmpassword"
                            label="Confirm Password"
                            type="password"
                            id="confirmpassword"
                            disabled={isLoading}
                            value={confirmPassword}
                            withRequiredValidator
                            onChange={(e: any) => setConfirmPassword(e.target.value.toString())}
                            validators={[
                                `required`,
                                `minStringLength:6`,
                            ]}
                            errorMessages={['This field is required', 'This field must be at least 6 characters long']}
                            autoComplete={"current-password-confirm-" + generateGuid()}
                            helperText={password && confirmPassword && password === confirmPassword ? `✓ Passwords match` : confirmPassword ? "Passwords don't match" : ""}
                        />

                    </Grid>

                    <Grid item xs={12}>
                    </Grid>

                    <Grid item xs={12}>
                        <PrimaryButton
                            variant="primary"
                            type="submit"
                            disabled={isLoading}>
                            Reset Password
                        </PrimaryButton>

                    </Grid>
                </Grid>
            </ValidatorForm>

            <Link style={useStyles.backToLogin} to={"/login"}>
                Back to Log In screen
            </Link>

        </div>
    );
}